import React, { useMemo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { roleCheck } from "utils/index"
import { Container } from "react-bootstrap"
import FilterDropdown from "components/FilterDropdown"
import SearchInput from "components/SearchInput"
import Loader from "components/Loader"
import AnchorButton from "components/AnchorButton"
import { get } from "lodash";
import {
  PROCESSOR,
  PROCESSOR_3D,
  DRAFTING_3D_MANAGER
} from "utils/constants"
import { getJobServicesProcessing } from "requesters/jobServiceRequester"
import { getFilteredProducts } from "requesters/productRequester"
import { getBaseUrl, getCurrentRole, getCurrentUser } from "../../reducers";
import { capitalizeString } from "../../../../utils";
import JobServicesByStateTable from "./JobServicesByStateTable";

const Processing = () => {
  const baseUrl = useSelector(getBaseUrl)
  const currentUser = useSelector(getCurrentUser)
  const systemRole = currentUser.attributes.role
  const currentTeamRole = currentUser.attributes.current_team_role
  const currentRole = useSelector(getCurrentRole)
  const isProcessor = roleCheck(systemRole, currentRole, PROCESSOR)
  const is3DProcessor = roleCheck(systemRole, currentRole, PROCESSOR_3D)
  const is3DDraftingManager = roleCheck(systemRole, currentTeamRole, DRAFTING_3D_MANAGER)
  const canAccess = isProcessor || is3DProcessor || is3DDraftingManager

  if (!canAccess) window.location = "/"

  const initialFilters = {
    by_job_type: undefined,
    by_keyword: undefined
  }
  const [filters, setFilters] = useState(initialFilters)
  const [requesting, setRequesting] = useState(false)
  const [jobServicesProcessing, setJobServicesProcessing] = useState([])
  const [jobTypeOptions, setJobTypeOptions] = useState([])
  const [dropdownFiltersChanged, setDropdownFiltersChanged] = useState(false)

  const fetchData = () => {
    setRequesting(true)
    getJobServicesProcessing(baseUrl, filters)
    .then(res => {
      if (res.status === 200) {
        const jobServices = get(res, "response", {})
        setJobServicesProcessing(jobServices)
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
    .finally(() => setRequesting(false))
  }

  const fetchJobTypeOptions = () => {
    getFilteredProducts(baseUrl, "processing")
    .then(res => {
      if (res.status === 200) {
        const products = Object.values(_.get(res.response, "product", {}))
        const allJobTypes = products.map(js => ([js.attributes.name, js.id]))
        setJobTypeOptions(allJobTypes)
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
  }

  const onSearch = e => {
    e.preventDefault()
    fetchData()
  }

  const onSetFilters = (key, val) => {
    const newFilters = { ...filters }
    newFilters[key] = val
    setFilters(newFilters)
    if (key !== "by_keyword") {
      setDropdownFiltersChanged(true)
    }
  }

  const getFilterName = (key, options) => {
    const selectedOption = options.find(o => o[1] === filters[key])
    const filteredName = selectedOption ? selectedOption[0] : ""

    return filteredName
  }

  useEffect(() => {
    fetchData()
    fetchJobTypeOptions()
  }, [])

  useEffect(() => {
    if (dropdownFiltersChanged) {
      fetchData()
      setDropdownFiltersChanged(false)
    }
  }, [dropdownFiltersChanged])

  return (
    <Container fluid className="">
      <div className="container-inner">
        <div className="d-flex justify-content-between align-items-center header-tabs-container">
          <div className="header-tabs">
            <h1>DATA PROCESSING</h1>
          </div>
          <div className="header-buttons">
          </div>
        </div>
        <div className="table-listing-filters d-md-flex justify-content-between">
          <div>
            <div className="btn-group mr-2">
              <SearchInput
                value={filters.by_keyword}
                setValue={val => onSetFilters("by_keyword", val)}
                handleSubmit={onSearch}
                disableSubmit={requesting} />
            </div>
            <div className="btn-group mr-2">
              <FilterDropdown
                title="Job Type"
                filteredName={getFilterName("by_job_type", jobTypeOptions)}
                setFilter={val => onSetFilters("by_job_type", val)}
                options={jobTypeOptions} />
            </div>
            <div className="btn-group">
              <AnchorButton
                className="f-small"
                onClick={() => {
                  setFilters(initialFilters)
                  setDropdownFiltersChanged(true)
                }}>
                Clear Filters
              </AnchorButton>
            </div>
          </div>
        </div>
        { requesting ? <Loader />
          : (
            <JobServicesByStateTable
              jobServices={jobServicesProcessing}
              setJobServices={setJobServicesProcessing}
              reloadData={fetchData} />
          )}
      </div>
    </Container>
  )
}

export default Processing